import { render, staticRenderFns } from "./mods.vue?vue&type=template&id=f40f8734"
import script from "./mods.vue?vue&type=script&lang=js"
export * from "./mods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports